"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  slidesProp: '4',
  aspectRatio: '16:9',
  slidesWrapper: 'box',
  durationProp: '0.5s',
  functionProp: 'linear',
  showArrows: true,
  showDots: true,
  showHead: true,
  showText: true,
  showLink: true,
  autoPlay: false,
  autoPlayBehavior: 'infinite',
  autoPlayIntervalProp: '1s',
  autoPlayDelayProp: '0s',
  autoPlayPauseProp: '5s'
};
exports["default"] = _default;